import React from "react";
import { Accordion } from "react-bootstrap";
import styles from './CsplAccordion.css';
import CsplLabel from '../CsplLabel/CsplLabel';
import { VideoKYCStatusEnum } from "../../../Enumeration/VideoKYCStatusEnum";

function CsplAccordion(props) {

    return (
        <div className="App">
            {props.List.map(list=> (
                <Accordion className="accordion_style">
                    <Accordion.Item>
                        <Accordion.Header variant="link"><span className='questions'>{list.question}</span>
                            {list.value === VideoKYCStatusEnum.Pass && <span className='score_button_pass' >{list.value}</span>}
                            {list.value === VideoKYCStatusEnum.Fail && <span className='score_button_fail' >{list.value}</span>}</Accordion.Header>
                        <Accordion.Body>
                            <div className='dotted_line'>
                                <table className="table table-striped table-bordered border-white table-responsive">
                                        <tbody className={styles.table_alternate_color}>  
                                            {list.valuesList.map(lists =>(
                                                <tr>
                                                    <th scope="row" className={styles.table_header}><CsplLabel label={lists.label}></CsplLabel></th>
                                                    <td>{lists.value}</td>
                                                </tr> 
                                            ))}
                                        </tbody>
                                </table>
                            </div> 
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

            ))}
        </div>
    );
}
export default CsplAccordion;